export const MAX_AVAILABLE_CARDS_AMOUNT = 5
